import { useState } from 'react';
import './Contact.css';

function Contact({ siteData }) {
  const contact = siteData?.contact || {};
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'General Inquiry',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) return;
    setSubmitted(true);
  };

  return (
    <div className="page-shell contact-page">
      <div className="page-intro contact-hero">
        <span className="contact-badge">Global Headquarters & Outreach</span>
        <h1 className="page-title">Contact & Partnership Inquiries</h1>
        <p className="page-subtitle">
          We welcome collaboration with governments, non-governmental organizations, academic institutions, and community leaders worldwide.
        </p>
      </div>

      <div className="content-wrap contact-layout" style={{ marginTop: '32px' }}>
        {/* Contact Form */}
        <section className="content-panel contact-form-panel">
          <h3 style={{ color: '#0c2f4d', marginTop: 0 }}>Send an Official Inquiry</h3>
          
          {submitted ? (
            <div className="contact-success-card">
              <span className="success-icon">✓</span>
              <h4>Thank you for reaching out!</h4>
              <p>Your message has been dispatched to the UNGDO Head Office. A representative will get in touch with you shortly.</p>
              <button
                type="button"
                className="primary-button"
                onClick={() => {
                  setSubmitted(false);
                  setFormData({ name: '', email: '', subject: 'General Inquiry', message: '' });
                }}
              >
                Send Another Message
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group-row">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    id="name"
                    type="text"
                    required
                    placeholder="e.g. Eleanor Vance"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    id="email"
                    type="email"
                    required
                    placeholder="e.g. eleanor@example.org"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Inquiry Subject</label>
                <select
                  id="subject"
                  value={formData.subject}
                  onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                >
                  <option value="General Inquiry">General Inquiry</option>
                  <option value="Infrastructural Funding">Infrastructural Funding Request</option>
                  <option value="SDG Partnership">SDG Partnership & Projects</option>
                  <option value="Community Support">Community Support & Relief</option>
                  <option value="Academic Programs">UN University Peace Programs</option>
                  <option value="Media & Press">Media & Press</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  rows="5"
                  required
                  placeholder="Please describe your organization, inquiry, or partnership request..."
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                />
              </div>

              <button type="submit" className="primary-button submit-btn">
                Submit Inquiry →
              </button>
            </form>
          )}
        </section>

        {/* Contact Info Cards */}
        <aside className="contact-sidebar">
          <div className="info-card contact-card">
            <h3>Head Office</h3>
            <p className="contact-address">
              <strong>United Nations Global Development Organization</strong><br />
              Head Office,<br />
              Delaware, USA
            </p>
            <div className="contact-detail-item">
              <strong>Email:</strong>
              <a href={`mailto:${contact.email || 'info@ungdo.org'}`}>{contact.email || 'info@ungdo.org'}</a>
            </div>
            <div className="contact-detail-item">
              <strong>Facebook:</strong>
              <a href={contact.facebook || 'https://web.facebook.com/unglobaldevorg'} target="_blank" rel="noreferrer">
                unglobaldevorg
              </a>
            </div>
          </div>

          <div className="info-card contact-card">
            <h3>Office Hours</h3>
            <p style={{ margin: '0 0 8px', fontSize: '0.9rem', color: '#405a73' }}>
              <strong>Monday – Friday:</strong> 9:00 AM – 5:00 PM EST
            </p>
            <p style={{ margin: 0, fontSize: '0.9rem', color: '#405a73' }}>
              <strong>Saturday & Sunday:</strong> 11:00 AM – 3:00 PM EST
            </p>
          </div>
        </aside>
      </div>
    </div>
  );
}

export default Contact;
